import "core-js/modules/es.number.constructor.js";
import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BImageWithBlurredBackground',
  props: {
    imageSrc: {
      type: String,
      default: undefined
    },
    blurAmount: {
      type: Number,
      default: 16
    },
    opacity: {
      type: Number,
      default: 0.8
    },
    maxHeight: {
      type: String,
      default: '616px'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    _useCssVars(function (_vm, _setup) {
      return {
        "14969d8f": _setup.props.maxHeight
      };
    });
    var backgroundStyles = computed(function () {
      return {
        'background-image': "url(".concat(props.imageSrc, ")"),
        filter: "blur(".concat(props.blurAmount, "px)"),
        opacity: props.opacity
      };
    });
    return {
      __sfc: true,
      props: props,
      backgroundStyles: backgroundStyles
    };
  }
});